/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "S desna na lijevo",
		"timeZoneID": "Vremenska zona",
		"skin": "Stil",
		"metricsFileImportTask": "Novi import iz datoteka",
		"displayMode": "Default pogled",
		"credentialRenewed": "Vaše vjerodajnice su obnovljene s trenutnim korisničkim ID-om i lozinkom.",
		"productLocale": "Jezik proizvoda",
		"toggleDisabled": "isključeno",
		"credentialChange": "Obnovi",
		"log_level_Debug": "Debug",
		"confirmNewPassword": "Potvrda nove lozinke",
		"unsavedViewMsg2": "Vaše promjene će biti izgubljene ako ih prije ne spremite.",
		"supportPortalErrorMessage": "Pokušajte ponovno.  Ako se problem nastavi, kontaktirajte svog administratora.",
		"legalText": "Licencirani materijali - Vlasništvo IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, IBM-ov logo, ibm.com i Cognos su zaštitni znakovi ili registrirani zaštitni znakovi u vlasništvu International Business Machines Corp. i registrirani su u mnogim pravnim nadležnostima u svijetu. Trenutna lista IBM-ovih zaštitnih znakova dostupna je na web stranici www.ibm.com/legal/copytrade.shtml. Ovaj program se licencira u skladu s odredbama licencnog ugovora koji dolazi s programom. Licencni ugovor može se nalaziti u folderu programskog direktorija ili u knjižnici s nazivom \"License\" ili \"Non_IBM_License\", ako je primjenjivo, a možete ga dobiti i u tiskanom obliku. Molim, pažljivo pročitajte ugovor prije upotrebe programa. Upotrebom programa pristajete na te odredbe.",
		"groupsAndRoles": "Grupe i uloge",
		"metricsMaintenanceTask": "Novo održavanje",
		"email": "E-pošta",
		"contextual": "Kontekstualno",
		"resetHome": "Reset na default",
		"ltr": "S lijeva na desno",
		"credentials": "Vjerodajnice",
		"logging_congfig_title": "Zapisivanje",
		"changePasswordTitle": "Promjena moje lozinke",
		"format": "Format izvještaja",
		"showUnread": "Pokaži nepročitano",
		"AILearning_active": "AI učenje je uključeno:",
		"docsErrorMessage": "Pokušajte ponovno.  Ako se problem nastavi, kontaktirajte svog administratora.",
		"toggleEnabled": "uključeno",
		"homeSetError": "Pojavila se greška prilikom postavljanja defaultne početne stranice, pokušajte zatvoriti pa otvoriti ovaj pogled.",
		"passwordChange": "Promijenite svoju lozinku",
		"profile": "Profil",
		"pdfRestricted": "PDF (ograničeno)",
		"drillThrough": "Definicije bušenja kroz",
		"homeSet": "Vaš početak je uspješno postavljen",
		"regionalOptions": "Regionalne opcije",
		"myPreferences": "Moje preference",
		"defaultHome": "Default",
		"version": "Verzija",
		"controller": "Controller",
		"manage": "Upravljanje",
		"biDirectionalFeaturesEnabled": "Podrška za dvosmjerni jezik",
		"newFeaturesErrorTitle": "Poveznica za nove funkcije nije radila",
		"passwordMatch": "Podudaranje lozinki",
		"updateProfileAndsettings": "Ažuriraj profil i postavke",
		"dashboardConsole": "Radni prostor",
		"legacyAppsSlideoutLabel": "Dostupne naslijeđene aplikacije",
		"logging_config_description": "Zapisivanje u dnevnik se koristi za rješavanje problema. Posavjetujte se sa svojim administratorom u vezi postavki.",
		"confirmDeletion": "Potvrda brisanja",
		"signInButtonText": "Prijava",
		"dataSourceCredentials": "Vjerodajnice poslužitelja podataka",
		"AILearningConfigurationSlideoutAllyLabel": "Konfiguracija AI učenja",
		"loadingSettings": "Učitavanje postavki",
		"spreadsheetMLRestricted": "Excel (ograničeno)",
		"manageAILearning": "AI učenje",
		"xlsxDataRestricted": "Excel podaci (ograničeno)",
		"advanced": "Napredne opcije",
		"ok": "OK",
		"changeEmail": "Promijeni",
		"showHints": "Pokaži napomene",
		"general": "Opće",
		"xlsxData": "Excel podaci",
		"newPassword": "Nova lozinka",
		"hideAll": "Sakrij sve",
		"confirmPassword": "Potvrda lozinke",
		"AILearning_config_description": "Poboljšajte preporuke proizvoda tako da Cognos Analyticsu omogućite da nauči kako ga vi koristite.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Poveznica za portal podrške ne radi",
		"log_level_Warn": "Upozorenje",
		"contentSettings": "Postavke sadržaja",
		"setHomeButton": "Postavi",
		"myCapabilities": "Moje sposobnosti",
		"homePage": "Početna stranica",
		"helpErrorMessage": "Pokušajte ponovno.  Ako se problem nastavi, kontaktirajte svog administratora.",
		"loadingProfile": "Učitavanje profila",
		"portal": "Portal",
		"metricsPackage": "Novi paket",
		"myCredentials": "Moje vjerodajnice",
		"credentialCreate": "Kreiraj",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Ne može se ažurirati lozinka",
		"showHiddenObjects": "Pokaži skrivene unose",
		"csv": "CSV",
		"docsErrorTitle": "Poveznica za dokumentaciju ne radi",
		"log_level_Error": "Greška",
		"wrongPassword": "Ne može se provjeriti ovlaštenje",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informacije",
		"welcomeBanner": "Uvodnik dobrodošlice",
		"helpErrorTitle": "Poveznica za pomoć ne radi",
		"contentLocale": "Jezik sadržaja",
		"pdf": "PDF",
		"oldPassword": "Stara lozinka",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Značajke pristupačnosti",
		"manageLogging": "Zapisivanje",
		"loggingConfigurationSlideoutA11yLabel": "Konfiguracija zapisivanja",
		"communityErrorTitle": "Poveznica za zajednicu ne radi",
		"companionApps": "Popratne aplikacije",
		"setHomeLabel": "Postavi početak na (trenutni pogled)",
		"metricsExportTask": "Novi eksport",
		"csvRestricted": "CSV (ograničeno)",
		"newFeaturesErrorMessage": "Pokušajte ponovno.  Ako se problem nastavi, kontaktirajte svog administratora.",
		"contributor": "Contributor",
		"showAll": "Pokaži sve",
		"logging_active": "Zapisivanje je uključeno:",
		"html": "HTML",
		"profileAndSettings": "Profil i postavke",
		"baseTextDirection": "Osnovni smjer za tekst",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Lozinka",
		"invalidEmail": "Unesite važeću adresu e-pošte",
		"credentialCreateSuccess": "Uspješno ste kreirali vaše vjerodajnice",
		"settings": "Postavke",
		"restrictedFormatSelected": "Nemate mogućnost kreiranja izvještaja u ovom formatu, ali\nmožete pristupiti izvještajima spremljenima u ovom formatu.",
		"usageDataDeletionConfirmation": "Brisanje podataka o upotrebi resetira AI učenje.  Jeste li sigurni da želite izbrisati podatke o upotrebi?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Pregled detalja",
		"deleteUsageData": "Izbriši podatke o upotrebi:",
		"showPassword": "Pokaži lozinku",
		"AILearning_config_title": "AI učenje",
		"myPreferencesSlideoutLabel": "Profil i postavke",
		"passWordChangeSuccess": "Uspješno ste promijenili vašu lozinku",
		"logging_level": "Razina zapisivanja dnevnika:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Pokušajte ponovno.  Ako se problem nastavi, kontaktirajte svog administratora.",
		"cancel": "Opoziv",
		"shareSetError": "Ova akcija se ne može izvesti prije nego zatvorit i ponovno otvorite ovaj pogled.",
		"passwordNotMatch": "Uh, lozinke se ne podudaraju",
		"xml": "XML",
		"xmlRestricted": "XML (ograničeno)",
		"openMenu": "Otvori izbornik",
		"closeMenu": 'Zatvori izbornik'
});